import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindAppsDownloadAndEngagementFilter from "../../../../models/AndroidDownloadAndEngagementFilter/AndroidDownloadAndEngagementFilter";
import DownloadEngagementFilter from "../DownloadEngagementFilter";

const AppAndroidDownloadEngagementFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsDownloadAndEngagementFilter>) => {
    return (
        <DownloadEngagementFilter
            filter={filter}
            onFilterUpdate={onFilterUpdate}
            value={value}
            hasDeviceFilter={false}
        />
    );
};

export default AppAndroidDownloadEngagementFilter;
